module.exports = __webpack_public_path__ + "media/images/countryrect/si-cc49d05d96b5e1f2b15ef16dbb6abdfa.svg";